export default () => {
    const navbar = document.querySelector('.navbar__custom');
    navbar &&
        window.addEventListener('scroll', () => {
            if (window.scrollY > 30) {
                navbar.classList.add('shadowed');
            } else {
                navbar.classList.remove('shadowed');
            }
        });
};
